module.exports = __webpack_public_path__ + "img/cue-90s.22e253d4.png";